import React from 'react';
import { Info } from 'lucide-react';

interface InfoAlertProps {
  title?: string;
  children: React.ReactNode;
}

export const InfoAlert: React.FC<InfoAlertProps> = ({ title, children }) => {
  return (
    <div className='not-prose my-6 bg-blue-50 dark:bg-blue-950 border-l-4 border-blue-500 p-4 rounded-r-lg'>
      <div className='flex gap-3'>
        <Info className='h-5 w-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5' />
        <div className='flex-1'>
          {title && (
            <h4 className='font-semibold text-blue-900 dark:text-blue-100 mb-2'>{title}</h4>
          )}
          <div className='text-sm text-blue-800 dark:text-blue-200 leading-relaxed'>{children}</div>
        </div>
      </div>
    </div>
  );
};
